<template>
  <div class="min-h-screen bg-white p-8 flex flex-col items-center">
    <div class="w-full max-w-2xl flex flex-col items-center">

      <h1 class="text-2xl font-bold text-gray-800 mb-10 text-center">
        Edit Login Page Image
      </h1>

      <div class="w-full flex flex-col items-start">
        <span class="text-md text-gray-700 mb-1 ml-1">Change Image</span>

        <div
          class="border-2 border-dashed border-black p-4 w-full flex justify-center items-center cursor-pointer bg-white"
          @click="triggerInput"
        >
          <div
            class="bg-gray-100 border border-gray-300 flex items-center justify-center overflow-hidden"
            style="width: 100%; height: 500px;"
          >
            <img
              v-if="previewUrl"
              :src="previewUrl"
              alt="Login page image"
              class="w-full h-full object-contain"
            />
            <div v-else class="w-full h-full bg-gray-200" />
          </div>
        </div>

        <div class="w-full flex justify-center mt-4">
          <button
            @click="selectedFile ? save() : triggerInput()"
            :disabled="saving"
            class="px-8 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700 transition disabled:opacity-60"
          >
            {{ saving ? 'Saving...' : selectedFile ? 'Save' : 'Choose Image' }}
          </button>
        </div>
      </div>

      <input
        ref="fileInput"
        type="file"
        accept="image/*"
        class="hidden"
        @change="onFileChange"
      />

      <p v-if="successMsg" class="mt-3 text-green-600 text-sm font-medium">{{ successMsg }}</p>
      <p v-if="errorMsg" class="mt-3 text-red-500 text-sm font-medium">{{ errorMsg }}</p>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "EditLoginImage",
  data() {
    return {
      previewUrl: null,
      selectedFile: null,
      saving: false,
      successMsg: "",
      errorMsg: "",
    };
  },
  methods: {
    triggerInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.selectedFile = file;
      this.previewUrl = URL.createObjectURL(file);
      this.successMsg = "";
      this.errorMsg = "";
    },
    async save() {
      if (!this.selectedFile) return;
      this.saving = true;
      this.successMsg = "";
      this.errorMsg = "";
      try {
        const formData = new FormData();
        formData.append("image", this.selectedFile);
        await api.post("/accounting/settings/login-image", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        this.successMsg = "Image saved successfully.";
      } catch (e) {
        this.errorMsg = "Failed to save image. Please try again.";
        console.error(e);
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
